import { FC } from 'react';

export interface TopBarOptionItemProps {
    title: string;
    amount?: number;
    total?: number;
    selected?: boolean;
    disabled?: boolean;
    leftProgressBarClassName: string;
    rightProgressBarClassName: string;
    onClick?: () => void;
}

const getProgressBarFlexWeights = (amount: number | undefined, total: number | undefined) => {
    if (amount === undefined || total === undefined) {
        return {
            left: 0.75,
            right: 0.25
        };
    }

    if (total === 0) {
        return {
            left: 0,
            right: 1
        };
    }

    return {
        left: amount / total,
        right: 1 - amount / total
    };
};

export const TopBarOptionItem: FC<TopBarOptionItemProps> = ({
    title,
    amount,
    total,
    disabled = false,
    selected = false,
    leftProgressBarClassName,
    rightProgressBarClassName,
    onClick
}) => {
    const progressBarWeights = getProgressBarFlexWeights(amount, total);

    return (
        <div
            className={`flex-1 p-2 rounded-[8px] flex flex-col gap-2 transition-colors hover:bg-[#F5FAFF] ${
                selected ? 'bg-sf-gray-50' : 'bg-sf-gray-0'
            } ${disabled ? '' : 'hover:cursor-pointer'}`}
            onClick={!disabled ? onClick : undefined}>
            <div className="flex justify-between">
                <span className="font-sf text-12">{title}</span>
                {amount !== undefined && (
                    <span className="font-sf-poppins text-13 font-bold leading-[15px] tracking-[0.203px]">
                        {amount}
                    </span>
                )}
            </div>
            <div className="flex gap-0.5 width w-full rounded-[2px] overflow-hidden">
                {!!progressBarWeights.left && (
                    <div className={`h-1 ${leftProgressBarClassName}`} style={{ flex: progressBarWeights.left }} />
                )}
                {!!progressBarWeights.right && (
                    <div className={`h-1 ${rightProgressBarClassName}`} style={{ flex: progressBarWeights.right }} />
                )}
            </div>
        </div>
    );
};
